<template>
    <div>      

      <nav class="navbar navbar-expand-lg navbar-dark sticky-top">
        <div class="container"> 
                      
          <a class="navbar-brand fw-bold" href="/">
            <img src="../assets/logo.png" class="img-fluid" style="width: 280px;" />
          </a>

          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav"> 
            <span class="navbar-toggler-icon"></span>
          </button>

            <div class="collapse navbar-collapse" id="mainNav">
                <ul class="navbar-nav ms-auto">
                    <li class="nav-item">
                        <router-link class="nav-link" to="/">HOME</router-link>              
                    </li>           
                    <li class="nav-item">
                        <router-link class="nav-link" to="/about">ABOUT</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/news">NEWS</router-link>
                    </li>                               
                    <li class="nav-item">
                        <router-link class="nav-link" to="/service">SERVICES</router-link>
                    </li>    
                    <li class="nav-item">
                        <router-link class="nav-link" to="/experience">EXPERIENCE</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/contact">CONTACT</router-link>
                    </li>               
                </ul>
            </div>

        </div>
      </nav>

        <main class="container-fluid mt-0">
            <router-view/>
        </main>

        <footer class="site-footer py-5">
          <div class="container">
            <!-- Partners row -->
            <div class="row mb-4">
              <div class="col-12">
                <h5 class="text-light mb-3 text-center">Business Partners</h5>
                <div class="partners d-flex flex-wrap align-items-center justify-content-center">
                  <a v-for="partner in partners" :key="partner.name" :href="partner.href || '#'" target="_blank" rel="noopener" class="partner-link d-flex flex-column align-items-center justify-content-center m-2">
                    <img :src="partner.logo" :alt="partner.name" class="partner-logo img-fluid"/>                    
                  </a>
                </div>
              </div>
            </div>

            <!-- Links row: vertical on XS, horizontal on MD+ -->
            <div class="row" style="padding-bottom: 36px;">
              <div class="col-12 text-center">
                <nav aria-label="footer-navigation">
                  <ul class="nav justify-content-center flex-column flex-md-row mb-3 mb-md-0">
                    <li class="nav-item">
                      <router-link class="nav-link px-2 text-light" to="/about">ABOUT</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link px-2 text-light" to="/news">NEWS</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link px-2 text-light" to="/service">SERVICES</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link px-2 text-light" to="/experience">EXPERIENCE</router-link>
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link px-2 text-light" to="/contact">CONTACT</router-link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            <!-- Company info row: aligned with left (company + privacy) and right (terms) -->
            <div class="row mt-3 mt-md-4">
              <div class="col-12">
                <div class="footer-bottom d-flex align-items-center justify-content-between flex-column flex-md-row">
                  <div class="footer-left d-flex align-items-center">
                    <span class="footer-company" style="font-size: 0.7rem;">&copy; 2005 - {{ year }} {{ COMPANYFULLNAME }} All rights reserved.</span>
                    <a class="link-light text-decoration-none ms-3" href="#">Privacy Policy</a>
                    <a class="link-light text-decoration-none" href="#">Terms of Service</a>
                  </div>
                  <div class="footer-right">
                    <a href="https://it.chenhometech.ca" target="_blank">Web Design</a> provided by
                    <a href="https://it.chenhometech.ca" target="_blank">Chen Home Tech</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
    </div>
</template>


<script setup>

import { computed } from 'vue';
import {COMPANYFULLNAME} from '@/constants';

const year = computed(()=>new Date().getFullYear());

// Use build-aware URLs so images inside `src/assets` resolve correctly after bundling.
// This produces a string URL at build time (works with Vite and webpack).
const partners = [
  { name: 'Chen Home Tech Inc.', logo: new URL('../assets/partner/chenhometechlogo.png', import.meta.url).href, href: 'https://it.chenhometech.ca' }
];

</script>


<style scoped>
.navbar { min-height: 60px; }

/* Footer links: softer gray-white for lower brightness by default */
.site-footer .nav-link {
  color: rgba(255,255,255,0.65) !important;
  transition: color .12s ease;
}
.site-footer .nav-link:hover,
.site-footer .nav-link:focus {
  color: rgba(255,255,255,0.90) !important;
  text-decoration: none;
}

/* Footer policy / other anchors: slightly more muted than nav links */
.site-footer a.link-light {
  color: rgba(255,255,255,0.58);
  transition: color .12s ease;
}
.site-footer a.link-light:hover,
.site-footer a.link-light:focus {
  color: rgba(255,255,255,0.86);
}

/* Active item: a bit brighter than default but not full white */
.site-footer .nav-item.active .nav-link {
  color: rgba(255,255,255,0.80) !important;
}

/* Bottom row layout: center container, left group + right item with space-between */
.footer-bottom {
  max-width: 920px;
  margin: 0 auto;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

/* Left group: company name + privacy */
.footer-left { gap: 12px; }

.footer-right {
  font-size: 0.7rem;
}

.footer-right a {
  font-weight: 600;
  text-decoration: none;
}

/* Slightly muted footer policy links, keep consistent with other footer anchors */
.footer-left a,
.footer-right a {
  color: rgba(255,255,255,0.62);
}
.footer-left a:hover,
.footer-right a:hover {
  color: #ffffff;
  
}

/* Mobile: stack into three centered rows (company / privacy / terms) */
@media (max-width: 767.98px) {
  .footer-bottom {
    flex-direction: column;
    align-items: center;
  }
  .footer-left {
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }
  .footer-left .footer-company {
     margin: 0;      
  }
  .footer-left a { margin: 0; }
  .footer-right { margin-top: 6px; }
}

/* Partners */
.partners { gap: 12px; }
.partner-link { width: 220px; height: 80px; padding: 6px; background: rgba(255,255,255,0.02); border-radius: 6px; }
.partner-logo { max-height: 80px; max-width: 100%; object-fit: contain; }

@media (max-width: 575.98px) {
  .partner-link { width: 140px; height: 64px; }
  .partner-logo { max-height: 64px; }
}
</style>